type QueryValue = string | string[] | undefined;
type QueryParams = Record<string, QueryValue>;

function first(value: QueryValue) {
  return Array.isArray(value) ? value[0] : value;
}

export function getProductSearchHref(
  searchParams: QueryParams | undefined,
  updates: QueryParams,
) {
  const params = new URLSearchParams();
  const merged = { ...searchParams, ...updates };

  for (const [key, value] of Object.entries(merged)) {
    const resolved = first(value);
    if (resolved) params.set(key, resolved);
  }

  const query = params.toString();
  return query ? `?${query}` : "?";
}
